<template>
    <div
        ref="wrapperRef"
        class="server-icon pointer-events-none [&_svg]:h-full [&_svg]:w-full [&_svg]:fill-current"
        aria-hidden="true"
    ></div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Props {
    iconUrl: string
}

const props = defineProps<Props>()

const wrapperRef = ref<HTMLElement>()

fetch(props.iconUrl)
    .then((res) => res.text())
    .then((data) => {
        wrapperRef.value?.insertAdjacentHTML('afterbegin', data)

        const svg = wrapperRef.value?.querySelector('svg')
        svg?.removeAttribute('width')
        svg?.removeAttribute('height')
    })
</script>
